export default {
	addCity: 'Add city',
	city: 'City',
	country: 'Country',
	countryRequired: 'Country',
	options: 'Options',
	edit: 'Edit',
	editingCity: 'Editing city',
	areYouSureYouWantToDeleteCity: 'Are you sure you want to delete city from system?',
	cityCenterCoordinates: 'City center coordinates',
	latitude: 'Latitude',
	longitude: 'Longitude'
};
